import request from '@/utils/request';
// 组织列表
export function getOrganizeList(params) {
  return request({
    url: '/orders/organize/index',
    method: 'get',
    params: params
  });
}
// 渠道菜单
export function getChannelList(params) {
  return request({
    url: '/malldecoration/mall-decoration/channel-menu-index',
    method: 'get',
    params: params
  });
}
// 启用禁用
export function changeMenuStatus(data) {
  return request({
    url: '/malldecoration/mall-decoration/change-menu-status',
    method: 'post',
    data: data
  });
}
// 制卡列表
export function getCardMarkList(params) {
  return request({
    url: '/orders/card-make/index',
    method: 'get',
    params: params
  });
}
// 添加制卡
export function addCardMark(data) {
  return request({
    url: '/orders/card-make/add',
    method: 'post',
    data: data
  });
}
// 添加制卡
export function updateCardMark(data) {
  return request({
    url: '/orders/card-make/update',
    method: 'post',
    data: data
  });
}
// 审批
export function cardMarkAudit(params) {
  return request({
    url: '/orders/card-make/audit',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 导出
export function cardMarkExport(params) {
  return request({
    url: '/orders/card-make/export',
    method: 'get',
    params: params
  });
}
// 添加 参数配置
export function addParamConfig(data) {
  return request({
    url: '/package/package-config/manage-config-update',
    method: 'post',
    data: data
  });
}
export function addManageParamConfig(data, type) {
  var url = {
    1: '/package/package-config/manage-config-operate-commission',
    2: '/package/package-config/manage-config-operate-basic',
    3: '/package/package-config/manage-config-operate-rule',
    4: '/package/package-config/manage-config-partial-permissions'
  }[type];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

// 获取 参数配置
export function getParamConfig(params) {
  return request({
    url: '/package/package-config/manage-config-info',
    method: 'get',
    params: params
  });
}
// 获取账户余额
export function getBalanceChannel(params) {
  return request({
    url: '/balance/balance-channel/detail',
    method: 'get',
    params: params
  });
}
// 获取账户余额流水
export function getBalanceChannelLog(params) {
  return request({
    url: '/balance/balance-channel/detail-log',
    method: 'get',
    timeout: 30000,
    params: params
  });
}
// 发票管理列表
export function getInvoicesList(params) {
  return request({
    url: '/user/channel-invoice-manage/index',
    method: 'get',
    params: params
  });
}
// 发票类型列表
export function getInvoiceConfig(params) {
  return request({
    url: '/user/channel-invoice-manage/get-invoice-config',
    method: 'get',
    params: params
  });
}
// 添加编辑发票信息
export function setInvoice(data) {
  return request({
    url: '/user/channel-invoice-manage/save-invoice',
    method: 'post',
    data: data
  });
}
// 删除发票
export function delInvoice(data) {
  return request({
    url: '/user/channel-invoice-manage/del-invoice',
    method: 'post',
    data: data
  });
}
// 限额配置
export function setLimitConfig(data) {
  return request({
    url: '/user/channel-invoice-manage/set-limit-config',
    method: 'post',
    data: data
  });
}
// 获取账户余额搜索框数据
export function getBalanceSearch(params) {
  return request({
    url: 'balance/balance-channel/search-types',
    method: 'get',
    params: params
  });
}
// 获取组织
export function getAllOrganize(params) {
  return request({
    url: '/orders/organize/all-tree',
    method: 'get',
    params: params
  });
}
// 获取分公司列表
export function getBranchCompanyList(params) {
  return request({
    url: '/orders/card-make/branch-office-select',
    method: 'get',
    params: params
  });
}
// 获取制卡明细
export function getMakeCardDetailList(params) {
  return request({
    url: '/orders/card-make/branch-office-page',
    method: 'get',
    params: params
  });
}
// 获取已售明细
export function getCardMakeSoldDetail(params) {
  return request({
    url: '/orders/card-make/detail',
    method: 'get',
    params: params
  });
}
// 获取项目制卡信息 - 锋火雷达
export function getCardMakeInfo(params) {
  return request({
    url: '/user/project-delivery/card-make-info',
    method: 'get',
    params: params
  });
}
// 获取项目交付-关联已有制卡批次列表 - 锋火雷达
export function getProjectDeliveryCardMakeList(params) {
  return request({
    url: '/user/project-delivery/card-make-list',
    method: 'get',
    params: params
  });
}
// 项目交付-关联已有制卡  - 锋火雷达
export function bindProjectDeliveryCardMake(data) {
  return request({
    url: '/user/project-delivery/bind-card-make',
    method: 'post',
    data: data
  });
}
// 项目交付-创建制卡 - 锋火雷达
export function addProjectDeliveryCardMake(data) {
  return request({
    url: '/user/project-delivery/create-card-make',
    method: 'post',
    data: data
  });
}
// 城市物料台账 搜索仓库列表
export function getCityMateriaBranchList(params) {
  return request({
    url: '/material/city-detail/branch-office-select',
    method: 'get',
    params: params
  });
}
// 公告管理-标签列表
export function getAnnouncementTags(params) {
  return request({
    url: '/orders/annc/tags',
    method: 'get',
    params: params
  });
}
// 公告管理-列表查询
export function getAnnouncementList(params) {
  return request({
    url: '/orders/annc/index',
    method: 'get',
    params: params
  });
}
// 公告管理-审核（通过/驳回）
export function auditAnnouncement(data) {
  return request({
    url: '/orders/annc/audit',
    method: 'post',
    data: data
  });
}
// 公告管理-撤回
export function withdrawAnnouncement(data) {
  return request({
    url: '/orders/annc/submit',
    method: 'post',
    data: data
  });
}

// 公告管理-撤销发布
export function revokeAnnouncement(data) {
  return request({
    url: '/orders/annc/cancel-publish',
    method: 'post',
    data: data
  });
}
// 公告管理-删除
export function deleteAnnouncement(data) {
  return request({
    url: '/orders/annc/delete',
    method: 'post',
    data: data
  });
}
// 公告管理-新增
export function createAnnouncement(data) {
  return request({
    url: '/orders/annc/create',
    method: 'post',
    data: data
  });
}
// 公告管理-编辑
export function editAnnouncement(data) {
  return request({
    url: '/orders/annc/update',
    method: 'post',
    data: data
  });
}
// 公告管理-详情
export function getAnnouncementDetail(params) {
  return request({
    url: '/orders/annc/view',
    method: 'get',
    params: params
  });
}
// 公告管理-操作日志
export function getAnnouncementLog(params) {
  return request({
    url: '/orders/annc/log',
    method: 'get',
    params: params
  });
}
// 查真实地址 
export function getRealAttachmentUrl(params) {
  return request({
    url: '/orders/annc/attachment-urls',
    method: 'get',
    params: params
  });
}
// 获取组织
export function getOrganize(params) {
  return request({
    url: '/orders/organize/all-tree',
    method: 'get',
    params: params
  });
}
// 【公告管理】已读/回执明细接口
export function getAnnouncementReadDetail(params) {
  return request({
    url: '/orders/annc/read-detail',
    method: 'get',
    params: params
  });
}
// 【公告管理】公告中心列表
export function getAnnouncementCenterList(params) {
  return request({
    url: '/orders/annc/my-list',
    method: 'get',
    params: params
  });
}

// 【公告管理】导航栏小铃铛最近公告统计
export function getAnnouncementRecentStats(params) {
  return request({
    url: '/orders/annc/recent-stats',
    method: 'get',
    params: params
  });
}

// 【公告管理】弹窗公告列表（左侧列表）
export function getAnnouncementPopupList(params) {
  return request({
    url: '/orders/annc/popup',
    method: 'get',
    params: params
  });
}
// 【公告管理】用户侧查看公告详情（右侧详情）
export function getAnnouncementUserView(params) {
  return request({
    url: '/orders/annc/user-view',
    method: 'get',
    params: params
  });
}
// 【公告管理】用户回执（我已知晓）
export function postAnnouncementCallback(data) {
  return request({
    url: '/orders/annc/callback',
    method: 'post',
    data: data
  });
}
// 首页获取公告弹框 是否显示
export function getAnnouncementPopupCount(params) {
  return request({
    url: '/orders/annc/popup-count',
    method: 'get',
    params: params
  });
}
// 【公告管理】恢复
export function restoreAnnouncement(data) {
  return request({
    url: '/orders/annc/restore',
    method: 'post',
    data: data
  });
}